import { lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { LoadingSpinner } from "./components/layouts/LoadingSpinner";
import RequireAuth from "./pages/RequireAuth";
import kraManagementRoute from "./utils/constants/kra-management/kra-management-route.constant";
import kpiManagementRoute from "./utils/constants/kpi-management/kpi-management-route.constant";
import employeeRoute from "./utils/constants/employee/employee-route.constant";
import departmentWiseReportRoute from "./utils/constants/report/department-wise-report.constant";
import kpiSummaryReportRoute from "./utils/constants/report/kpi-summary-report.constant";
import kraReportRoute from "./utils/constants/report/kra-report.constant";

const NoPermissionPage = lazy(() => import("./pages/NoPermission"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));
const LoginPage = lazy(() => import("./pages/LoginPage"));

// Overview
const OverviewPage = lazy(() => import("./pages/overview/OverviewPage"));

// KRA Management
const KRAManagementPage = lazy(
  () => import("./pages/kra-management/KRAManagementPage")
);
const KRAManagementAddPage = lazy(
  () => import("./pages/kra-management/KRAManagementAddPage")
);
const KRAManagementEditPage = lazy(
  () => import("./pages/kra-management/KRAManagementEditPage")
);

// KPI Management
const KPIManagementPage = lazy(
  () => import("./pages/kpi-management/KpiManagementPage")
);
const KPIManagementAddPage = lazy(
  () => import("./pages/kpi-management/KpiManagementAddPage")
);
const KPIManagementEditPage = lazy(
  () => import("./pages/kpi-management/KPIManagementEditPage")
);

// Employee
const EmployeePage = lazy(() => import("./pages/employee/EmployeePage"));
const EmployeeDetailPage = lazy(
  () => import("./pages/employee/EmployeeDetailPage")
);
const EmployeeKpiDetailPage = lazy(
  () => import("./pages/employee/EmployeeKpiDetailPage")
);

// Report
const KPISummaryReportPage = lazy(
  () => import("./pages/report/KpiSummaryPage")
);
const DepartmentWiseReportPage = lazy(
  () => import("./pages/report/DepartmentWiseReportPage")
);
const KRAReportPage = lazy(() => import("./pages/report/KraReportPage"));

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <RequireAuth />,
      children: [
        {
          path: "/no-permission",
          element: <NoPermissionPage />,
        },

        // Overview
        {
          path: "/",
          element: <OverviewPage />,
        },

        // KRA
        {
          path: kraManagementRoute.BASE_PATH,
          element: <KRAManagementPage />,
        },
        {
          path: kraManagementRoute.addPath(),
          element: <KRAManagementAddPage />,
        },
        {
          path: kraManagementRoute.editPath(":id"),
          element: <KRAManagementEditPage />,
        },

        // KPI
        {
          path: kpiManagementRoute.BASE_PATH,
          element: <KPIManagementPage />,
        },
        {
          path: kpiManagementRoute.addPath(),
          element: <KPIManagementAddPage />,
        },
        {
          path: kpiManagementRoute.editPath(":kpiId"),
          element: <KPIManagementEditPage />,
        },

        // Employee
        {
          path: employeeRoute.BASE_PATH,
          element: <EmployeePage />,
        },
        {
          path: employeeRoute.detailPath(":id"),
          element: <EmployeeDetailPage />,
        },
        {
          path: employeeRoute.kpiDetailPath(":id"),
          element: <EmployeeKpiDetailPage />,
        },

        // Report
        {
          path: departmentWiseReportRoute.BASE_PATH,
          element: <DepartmentWiseReportPage />,
        },
        {
          path: kpiSummaryReportRoute.BASE_PATH,
          element: <KPISummaryReportPage />,
        },
        {
          path: kraReportRoute.BASE_PATH,
          element: <KRAReportPage />,
        },
      ],
    },
    {
      path: "/no-permission",
      element: <NoPermissionPage />,
    },
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "*",
      element: <NotFoundPage />,
    },
  ]);

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default App;
